import {
  Smartphone,
  Globe,
  Printer,
  Scale,
  Wifi,
  Package,
  Zap,
} from "lucide-react";
import Button from "../../components/ui/button";
import { LeadFormDialog } from "./LeadFormDialog";
import { useTranslation } from "react-i18next";

const features = [
  {
    icon: Smartphone,
    title: "Works on Mobile, Tablet, Desktop",
    description: "Access your store from any device",
  },
  {
    icon: Globe,
    title: "Arabic + English Interface",
    description: "Perfect for Egyptian retailers",
  },
  {
    icon: Printer,
    title: "Receipt Printing & Barcode Scanning",
    description: "Professional checkout experience",
  },
  {
    icon: Scale,
    title: "Weighing Machine Compatible",
    description: "Seamless integration with scales",
  },
  {
    icon: Wifi,
    title: "Offline Mode – Keep Selling",
    description: "No internet? No problem!",
  },
  {
    icon: Package,
    title: "Inventory & Customer Tracking",
    description: "Know what's selling and who's buying",
  },
  {
    icon: Zap,
    title: "Setup in Just 10 Minutes",
    description: "Start selling today, not tomorrow",
  },
];

export const FeaturesSection = ({utms}) => {
  const { t } = useTranslation();
  return (
    <section className="py-8 md:py-12 bg-muted/30">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-foreground mb-8 md:mb-12">
          {t("Why Retailers Choose")} <span className="text-primary">Hisabak</span>
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-card p-4 md:p-6 rounded-xl shadow-[var(--shadow-soft)] hover:shadow-[var(--shadow-medium)] transition-all duration-300 border border-border text-center"
            >
              <div className="flex justify-center mb-3 md:mb-4">
                <div className="bg-blue-100 p-3 md:p-4 rounded-full flex items-center justify-center">
                  <feature.icon className="w-6 h-6 md:w-8 md:h-8 text-primary" />
                </div>
              </div>
              <h3 className="text-sm md:text-lg font-semibold text-foreground mb-1 md:mb-2">
                {t(feature.title)}
              </h3>
              <p className="text-[11px] md:text-sm text-muted-foreground">
                {t(feature.description)}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-primary/10 to-primary/10 border border-primary/20 rounded-xl md:rounded-2xl p-4 md:p-8 text-center">
          <p className="text-base sm:text-lg md:text-xl font-semibold text-foreground mb-4">
            {t("Want to see how it works? Fill the form now to get")}{" "}
            <span className="text-primary">{t("FREE trial access.")}</span>
          </p>
          <LeadFormDialog utms={utms}>
            <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 md:px-8 py-4 md:py-6 text-base md:text-lg">
              {t("Get Free Trial Access")}
            </Button>
          </LeadFormDialog>
        </div>
      </div>
    </section>
  );
};
